module.exports = __webpack_public_path__ + "resources/img/img_datatransporter_m_v2.74bb59736b94db0009d089ba2c30600b.png";